module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-logo-rs-6e02cd3bf470b58234d497eb98d05a4f.svg";